import { APPEARANCE_MODE_LIGHT } from './index';

export const cookiesKey = {
  themeMode: 'themeMode',
};

export const defaultSettings = {
  themeMode: APPEARANCE_MODE_LIGHT,
};
